<template>
  <div ref="echartContent" style="height: 400px;"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  components: {},
  props: ['xAxisData','seriesData','eachartsRefresh'],
  data() {
    return {}
  },
  watch: {
    eachartsRefresh(){
      this.init()
    },
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    init(){
      // let chartDom = document.getElementById('echartContent');
      let chartDom = this.$refs.echartContent
      let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: 'axis',
        },
        // grid: {
        //   left: '100px',
        //   right: '100px',
        // },
        xAxis: {
          type: 'category',
          data: this.xAxisData,
          axisLabel: {
            interval: 0
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.seriesData,
            type: 'bar',
            barWidth: 40,
            itemStyle: {
              normal: {
                color: 'rgba(24,144,255,0.85)'
              }
            }
          }
        ]
      };
      option && myChart.setOption(option);
    }
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>